import React , {useMemo} from 'react';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import FormHelperText from '@mui/material/FormHelperText';
import { fieldSizing } from '../../utils/utilities';
import Grid from '@mui/material/Unstable_Grid2';

const ITEM_HEIGHT = 75;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export default function MultipleSelectV2({
    label,
    name,
    options,
    value,
    setValue,
    error = false,
    errorMsg = "This is a required field.",
    disabled=false,
    fieldBlur,
    required,
    size,
    disabledItems=[]
}) {
    
    const fieldSize = useMemo( () => 
        fieldSizing(size)
    ,[size])

    const handleChange = (event) => {
        const { value } = event.target;
        if (setValue) {
            setValue(typeof value === 'string' ? value.split(',') : value);
        }
    };

    const handleOnBlur = () => {
        if(fieldBlur) fieldBlur();
    }

    return (
        <Grid xs={fieldSize.xs} sm={fieldSize.sm} md={fieldSize.md} lg={fieldSize.lg} >
            <FormControl fullWidth error={error}>
                <InputLabel>{label}</InputLabel>
                <Select
                    labelId="demo-multiple-chip-label"
                    // id="demo-multiple-chip"
                    multiple
                    value={value ? [...value]: []}
                    name={name}
                    onChange={handleChange}
                    onBlur={handleOnBlur}
                    input={<OutlinedInput  label={required ? `${label}*` : label} />}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((val) => (
                                <Chip key={val} label={val} />
                            ))}
                        </Box>
                    )}
                    MenuProps={MenuProps}
                    error={error}
                    disabled={disabled}
                >
                    {options.map((item) => (
                            <MenuItem key={item} value={item} disabled={ disabledItems.includes(item) } >
                                <Checkbox checked={value?.indexOf(item) > -1} />
                                <ListItemText primary={item}/>
                            </MenuItem>
                       
                    ))}
                </Select>
            </FormControl>
            <FormHelperText error> {error ? errorMsg : ""} </FormHelperText>

        </Grid >
    );
}